// Dashboard section DAO — list + replace for the `dashboard_sections` table.

import { BaseDao, type SupabaseClient } from '../base.ts';
import type { DashboardSection } from '../../types/dashboard.ts';

export class DashboardSectionDao extends BaseDao<DashboardSection> {
  protected readonly dependentResources = ['dashboard_sections'];

  constructor(sb: SupabaseClient) {
    super(sb, 'dashboard_sections');
  }

  async listByLocation(location: string): Promise<DashboardSection[]> {
    const { data, error } = await this.sb
      .from('dashboard_sections')
      .select('*')
      .eq('location', location)
      .order('position', { ascending: true });
    if (error) throw error;
    return (data ?? []) as DashboardSection[];
  }

  async deleteByLocation(location: string): Promise<void> {
    const { error } = await this.sb
      .from('dashboard_sections')
      .delete()
      .eq('location', location);
    if (error) throw error;
  }

  async bulkInsert(rows: Array<Partial<DashboardSection>>): Promise<DashboardSection[]> {
    if (rows.length === 0) return [];
    const { data, error } = await this.sb
      .from('dashboard_sections')
      .insert(rows as Record<string, unknown>[])
      .select();
    if (error) throw error;
    return (data ?? []) as DashboardSection[];
  }
}
